"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.find");
require("core-js/modules/es6.array.find-index");
require("core-js/modules/es6.function.name");
var _CipherTablePane = _interopRequireDefault(require("./CipherTablePane.vue"));
var _CipherConfig = _interopRequireDefault(require("./CipherConfig.vue"));
var _CipherJoinPane = _interopRequireDefault(require("./CipherJoinPane.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'Cipher',
  components: {
    CipherTablePane: _CipherTablePane.default,
    CipherConfigPane: _CipherConfig.default,
    CipherJoinPane: _CipherJoinPane.default
  },
  data: function data() {
    return {
      activeName: 'cipher_table',
      currentId: null,
      isEdit: false,
      showConfigTab: false,
      configKey: 0,
      joinTabs: []
    };
  },
  methods: {
    handleClick: function handleClick(tab) {
      this.activeName = tab.name;
    },
    handleTabRemove: function handleTabRemove(targetName) {
      if (targetName === 'cipher_config') {
        this.showConfigTab = false;
        this.activeName = 'cipher_table';
        this.currentId = null;
        this.isEdit = false;
        return;
      }
      // 关闭参与明细 Tab
      var joinIdx = this.joinTabs.findIndex(function (t) {
        return t.name === targetName;
      });
      if (joinIdx > -1) {
        this.joinTabs.splice(joinIdx, 1);
        if (this.activeName === targetName) this.activeName = 'cipher_table';
      }
    },
    handleToCipherConfig: function handleToCipherConfig(id) {
      var _this = this;
      this.currentId = id;
      this.isEdit = !!id;
      this.showConfigTab = true;
      this.configKey++;
      this.$nextTick(function () {
        _this.activeName = 'cipher_config';
      });
    },
    handleToCipherJoin: function handleToCipherJoin(payload) {
      var _this2 = this;
      var id = payload.id,
        title = payload.title,
        filters = payload.filters;
      var existing = this.joinTabs.find(function (t) {
        return t.activityId === id;
      });
      if (existing) {
        this.activeName = existing.name;
        if (filters) {
          this.$nextTick(function () {
            var ref = _this2.$refs[existing.name];
            var pane = Array.isArray(ref) ? ref[0] : ref;
            if (pane) pane.applyFilters(filters);
          });
        }
        return;
      }
      var name = "cipher_join_".concat(id);
      this.joinTabs.push({
        name: name,
        title: "\u53C2\u4E0E\u660E\u7EC6 - ".concat(title),
        activityId: id,
        activityTitle: title,
        filters: filters || null
      });
      this.activeName = name;
    },
    handleSuccess: function handleSuccess() {
      this.showConfigTab = false;
      this.activeName = 'cipher_table';
      this.currentId = null;
      this.isEdit = false;
      this.$refs.cipher_table.fetchData();
    },
    handleCancel: function handleCancel() {
      this.showConfigTab = false;
      this.activeName = 'cipher_table';
    }
  }
};